import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../contextStore/AuthContext';
import { blockedUsersRef, serverTimestamp } from '../../firebase/collections';
import { ToastContext } from '../../contextStore/ToastContext';
import './BlockButton.css';

function BlockButton({ userId, userName, onBlocked, className }) {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const { addToast } = useContext(ToastContext);
  const [loading, setLoading] = useState(false);

  if (!user || !userId || user.uid === userId) return null;

  const handleBlock = () => {
    if (!window.confirm(t('blockUser.blockConfirm'))) return;
    setLoading(true);
    blockedUsersRef()
      .add({
        blockerId: user.uid,
        blockedId: userId,
        createdAt: serverTimestamp(),
      })
      .then(() => {
        addToast(t('blockUser.userBlocked'), 'success');
        if (onBlocked) onBlocked();
      })
      .catch(() => {
        addToast(t('blockUser.blockFailed'), 'error');
      })
      .finally(() => setLoading(false));
  };

  return (
    <button
      type="button"
      className={className ? `blockUserBtn ${className}` : 'blockUserBtn'}
      onClick={handleBlock}
      disabled={loading}
    >
      {loading ? '...' : t('blockUser.blockUserButton')}
    </button>
  );
}

export default BlockButton;
